import About from '../'

export default {
  path: '/report/:token',
  name: 'About',
  component: About,
  meta: {
    main_menu: true
  }
}



// WEBPACK FOOTER //
// ./src/view/pages/About/route/index.js